import { useToast } from '@chakra-ui/react';
import {
  EvaluationEvent,
  UpdateEvaluationEventDto,
} from '@keyops-cep/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateEvaluationEventById } from '../api/evaluation-event.functions';
import i18n from '../utils/i18n';

export const useUpdateEvaluationEvent = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    EvaluationEvent, // Success response type
    unknown, // Error type
    {
      // Variable type (the argument for the mutation function)
      evaluationEventId: string;
      newEvaluationEventData: UpdateEvaluationEventDto;
    }
  >({
    mutationFn: ({ evaluationEventId, newEvaluationEventData }) =>
      updateEvaluationEventById(evaluationEventId, newEvaluationEventData), // The mutation function
    onSuccess: (updatedEvaluationEvent) => {
      if (updatedEvaluationEvent) {
        // Refetch all evaluation events
        queryClient.invalidateQueries({
          queryKey: ['get-all-evaluation-events'],
        });
        toast({
          title: i18n.t('evaluationEvent.form.successMessage'),
          variant: 'subtle',
          isClosable: true,
          status: 'success',
          position: 'top-right',
        });
      }
    },
    onError: (error) => {
      console.error(error);
      toast({
        title: i18n.t('errorComponent.title'),
        description: i18n.t('errorComponent.subTitle'),
        variant: 'subtle',
        isClosable: true,
        status: 'error',
        position: 'top-right',
      });
    },
  });
};
